module.exports = "https://www.gc-qa.gnp.com.mx/890b1c180b83600922f30537b766b7d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/vector_fail.png
// module id = 1865
// module chunks = 0